import { useQuery, gql } from '@apollo/client';

export type QueryL4ById = {
  l4ById: {
    isPayWithFixly?: boolean;
  };
};

export const usePWFCategoryQuery = (id?: string) => {
  const { data } = useQuery<QueryL4ById>(
    gql`
      query L4category($id: ID!) {
        l4ById(id: $id) {
          isPayWithFixly
        }
      }
    `,
    {
      skip: !id,
      variables: {
        id,
      },
    }
  );

  return Boolean(data?.l4ById?.isPayWithFixly);
};
